<template>
	<v-container fluid full-height>
		<v-row class="justify-center pt-12">
			<v-col class="text-center" cols="12">
				<span class="d-none d-sm-block display-2 font-weight-bold">VERIFY EMAIL</span>
				<span class="d-sm-none headline">VERIFY EMAIL</span>
			</v-col>
			<v-col class="text-center" cols="12">
				<span class>
					Thanks for creating your account at ElevenEleven. A verification link is sent to your registered mail address. Please click the link to verify your account and
					<router-link to="/signin">Sign-in</router-link>&nbsp; again to enjoy shopping!
				</span>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: "VerifyEmail",
	data() {
		return {};
	},
	methods: {}
};
</script>

<style>
</style>